import { render, staticRenderFns } from "./ProductElementRequiredValidation.vue?vue&type=template&id=5485a502&"
import script from "./ProductElementRequiredValidation.vue?vue&type=script&lang=js&"
export * from "./ProductElementRequiredValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports